import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/icon_star_rate_full.svg'
import _imports_1 from '@/assets/images/icon_star_half.svg'
import _imports_2 from '@/assets/images/icon_star_rate_empty.svg'


const _hoisted_1 = { class: "star" }
const _hoisted_2 = { class: "starRate" }
const _hoisted_3 = { class: "starRate__box" }
const _hoisted_4 = { key: 0 }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'StarRate',
  props: {
  id: {
    type: Number,
    default: 0,
  },
  modelValue: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {

const props = __props;

const rating = computed(()=>Number(props.id))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.floor(rating.value), (i) => {
          return (_openBlock(), _createElementBlock("span", { key: i }, _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              class: "starRate__star",
              src: _imports_0
            }, null, -1)
          ])))
        }), 128)),
        (rating.value % 1 !== 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                class: "starRate__star",
                src: _imports_1
              }, null, -1)
            ])))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - Math.floor(rating.value) - (rating.value % 1 !== 0 ? 1 : 0), (i) => {
          return (_openBlock(), _createElementBlock("span", { key: i }, _cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              class: "starRate__star",
              src: _imports_2
            }, null, -1)
          ])))
        }), 128))
      ])
    ])
  ]))
}
}

})